export default __webpack_public_path__ + "static/media/KOD0079-min.e44e7c2b.webp";